import { councilAlarmApi } from "@/lib/api"
import type { ApiResponseLeakTrendsDTO, LeakTrendsDTO } from "@/gen/api"
import { useQuery } from "@tanstack/react-query"

const useGetLeakGraph = (councilId: string, from?: string, to?: string) => {
  return useQuery({
    queryKey: [useGetLeakGraph.QUERY_KEY, councilId, from, to],
    queryFn: async () => {
      const response = await councilAlarmApi.getLeakAlarmGraph(councilId, from, to)
      return (response.data as ApiResponseLeakTrendsDTO).data as LeakTrendsDTO
    },
    enabled: !!councilId,
  })
}

useGetLeakGraph.QUERY_KEY = "leak-graph"

export default useGetLeakGraph
